import { AsapAction } from './AsapAction';
import { AsapScheduler } from './AsapScheduler';
export var asap = new AsapScheduler(AsapAction);
//# sourceMappingURL=asap.js.map